import axios from 'axios';
import React, {Component} from 'react';
import SVGInline from 'react-svg-inline';
import renderHTML from 'react-render-html';
import { bindActionCreators, compose } from "redux"
import { withProps, withStateHandlers } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps"
import {connect} from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import MapList from './main/map_list';
import Empty from './main/empty';
import NavBar from '../containers/parts/NavBar';

const WP_API_ENDPOINT = `${RT_API.root}wp/v2`;

class List extends Component {
	
	constructor(props) {
	    super(props)
	    this.state = {
	      selectedMarker: false
	    }
	}
	
	componentWillUpdate() {
		window.scrollTo(0, 0);
	}

	posts(){
		let posts = this.props.posts
		//delete events.loading
		return Object.entries(posts)

	}
	
	isSingle() {
		return 1 === this.props.posts.length;
	}
	
	renderPosts(posts) {
		if (posts.length) {
			return posts.map(post => {
				return (<MapList key={post.id}
				                 post={post}
				                 isSingle={this.isSingle()}/>);
			});
		} else {
			const counter = [...Array(20)];
			return counter.map((val, i) => {
				return (<Empty key={i}/>);
			});
		}
	}
	
	render() {
	
		return (
			<div className="map-wrapper scroll">
				<div className="row">
					{this.renderPosts(this.props.posts)}
				</div>
			</div>
		);
	}
}


function mapStateToProps({posts}) {
	return {posts};
}

export default connect(mapStateToProps)(List)



// WEBPACK FOOTER //
// ./src/components/list.js